// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {
  createApi,
  FetchArgs,
  fetchBaseQuery,
  BaseQueryApi,
} from "@reduxjs/toolkit/query/react";
import { config } from "../../config";
import { AuthState } from "../auth";

const baseQuery = fetchBaseQuery({
  baseUrl: config.apiBaseUrl,
  prepareHeaders: (headers, { getState }) => {
    const { auth } = getState() as { auth: AuthState<any> };
    if (auth.token && auth.token != "") {
      headers.set("Authorization", `Bearer ${auth.token}`);
    }
    return headers;
  },
  paramsSerializer: (params) => {
    let query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v != null) {
        if (Array.isArray(v)) {
          v.forEach((vv) => query.append(k, vv));
        } else query.append(k, v);
      }
    });
    return query.toString();
  },
});
const baseQueryWithResetToken = async (
  args: FetchArgs,
  api: BaseQueryApi,
  extraOptions: {}
) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    await api.dispatch(async (dispatch, _getState, extraArgument) => {
      /** Try refetch token, if failed, log out user */
      const { authService } = extraArgument;
      try {
        if (authService == null) {
          dispatch({ type: "auth/unauthenticated" });
        }
        const newAccessToken = await authService.refreshToken();
        if (newAccessToken != null) {
          dispatch({
            type: "auth/refetchTokenSucceed",
            payload: { token: newAccessToken },
          });
        } else {
          dispatch({ type: "auth/unauthenticated" });
        }
      } catch (err: unknown) {
        /** logout unauthenticated user to let them login again */
        dispatch({ type: "auth/unauthenticated" });
      }
    });

    result = await baseQuery(args, api, extraOptions);
  }
  return result;
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseSplitApi = createApi({
  baseQuery: baseQueryWithResetToken,
  tagTypes: [
    "AvailablePTUserCount",
    "AvailablePTUserCountByStations",
    "Shifts",
    "IncidentShifts",
    "Shift",
    "ShiftRequests",
    "ShiftApplication",
    "PtUsers",
    "PtUser",
    "BorrowingShiftRequest",
    "PtUserWorkingStatus",
    "PtUserWorkingStatuses",
    "PtUserUnreadShiftCount",
    "PtUserShiftCancel",
    "ShiftListForPtUser",
    "Notifications",
    "UnreadChatCount",
    "Announcements",
    "ShiftRequests",
    "PTGetShiftDetail",
    "PTGetShiftRequestByShift",
    "MasterShiftApplications",
    "AvailablePTUsers",
    "MasterShiftAvailablePTUsers",
    "MasterShiftAvailablePTUserCount",
    "MasterShiftAvailablePTUserCountByStations",
    "MasterShiftInvitationSentCount",
    "ValidateStationManagerInvite",
    "ShiftFullTimeAttendance",
    "TemplateMessageList",
  ],
  endpoints: () => ({}),
});
